import React from "react";
import { appstr } from "@coreapp/utils/appstr";
import UpgradeInfoContainer from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoContainer";
import { enumFeaturesList } from "@coreapp/constants";
import { UpgradeInfoCard } from "@/appComponents/Blocks/Composites/UpgradePopover/UpgradeInfoCard";

const UpgradePIT = () => {
  const archiveChartsDynamicText = {
    template: appstr("pit archive template"),
    formatConfig: {
      bold1: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("securely captured")
    }
  };

  const orgStructuresDynamicText = {
    template: appstr("pit org template"),
    formatConfig: {
      bold1: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("identify patterns")
    }
  };

  const stayAuditReadyDynamicText = {
    template: appstr("pit audit template"),
    formatConfig: {
      bold1: { type: "bold" }
    },
    replaceDict: {
      bold1: appstr("share historical")
    }
  };

  return (
    <UpgradeInfoContainer featureKey={enumFeaturesList.PIT}>
      <UpgradeInfoCard name="clock-rotate-left">
        <UpgradeInfoCard.Header>{appstr("Automatically archive charts")}</UpgradeInfoCard.Header>
        <UpgradeInfoCard.Body dynamic={archiveChartsDynamicText}>
          {appstr("pit archive message")}
        </UpgradeInfoCard.Body>
      </UpgradeInfoCard>
      <UpgradeInfoCard name="chart-tree-map-regular">
        <UpgradeInfoCard.Header>{appstr("Org structures")}</UpgradeInfoCard.Header>
        <UpgradeInfoCard.Body dynamic={orgStructuresDynamicText}>
          {appstr("pit org message")}
        </UpgradeInfoCard.Body>
      </UpgradeInfoCard>
      <UpgradeInfoCard name="file-shield">
        <UpgradeInfoCard.Header>{appstr("Stay audit ready")}</UpgradeInfoCard.Header>
        <UpgradeInfoCard.Body dynamic={stayAuditReadyDynamicText}>
          {appstr("pit audit message")}
        </UpgradeInfoCard.Body>
      </UpgradeInfoCard>
    </UpgradeInfoContainer>
  );
};

export default UpgradePIT;
